// EL LISTÓN DEL 80, EN UN SITIO Y CON SU PRUEBA.
//
//   «En cuanto uno pasa del 80 %, el 80 desaparece» (Jesús, 10-09)
//   «Cambia la lógica, que sea mayor o igual al 80» (Francisco, 12-09)
//
// LLEGAR AL 80 % YA ES CRUZARLO. Con un «mayor que» pelado el botón no se cumplía a sí
// mismo: al pulsar el 80 sobre un objetivo de 100 la proteína queda en 80 clavados, que no
// es MAYOR que el 80 %, así que el botón seguía ahí para siempre. Y la maqueta del 10-09
// enseña el caso exacto -- proteína 38,4 de 48, el 80 % justo -- con el letrero ya pasado a
// los hidratos y «a partir de aquí, un solo botón: el 100».
//
// EN GRAMOS Y NO EN PORCENTAJE (`srv * 10 >= tgt * 8`): así la cuenta sale redonda y no la
// tuerce el decimal que se pierde al dividir. Sin objetivo se da por cruzado, que es la
// misma regla con la que el motor decide las fases.
// POR ENCIMA DEL 80, NO EN EL 80 (Jesús, reunión del 25-09): «cuando selecciono 80 me cuadra
// el 80 pero me sigue dejando meter proteínas, que es lo que yo quiero; asegúrate de que al 81
// me deja [pasar]». Vuelve el «mayor que» estricto de Calma. REVIERTE el «mayor o igual» del
// 24-09 (entonces el 80 tenía que cruzar): manda lo más reciente.
export const cruzoElOchenta = (srv, tgt) => !(tgt > 0) || (srv * 10) > (tgt * 8);

// La fracción del botón. Dice 80 y pone el 80: estuvo un rato en 0,81 para forzar el cruce
// cuando la cantidad sugerida viene corta, y eso era un parche en el sitio equivocado que
// además hacía mentir al rótulo. Lo que corrige el redondeo es `cantidadDelOchenta`.
export const EL_OCHENTA = 0.8;

// HACIA ARRIBA Y NO AL MÁS CERCANO: el 80 % de una cantidad que ya viene corta se quedaba
// por debajo del listón. Es menos de un gramo por cada cien.
// Y HACIA ABAJO, para que el 80 se quede en el 80 y no lo cruce (25-09; antes se redondeaba
// hacia arriba justo para que cruzara).
//
// Y EL 80 % DE LO QUE FALTA, NO DE LA SUGERIDA (vídeo de Jesús del 27-09: «tú ya has cogido
// la proteína, aquí te tiene que seguir ofreciendo»). La sugerida puede pasarse un pelo del
// hueco (el 100 llega al 100 si hay margen): 410 g de claras daban 45,1 de proteína para un
// hueco de 45, y su 80 % (36,1) cruzaba el 80 % de 45. Con `aporta` (lo que da la sugerida en
// ese macro) y `falta` (lo que le queda a la comida), el 80 se queda en el 80 % de lo que falta.
export const cantidadDelOchenta = (sugerida, aporta = null, falta = null) => {
    let fraccion = EL_OCHENTA;
    if (aporta > 0 && falta >= 0 && aporta > falta) fraccion = EL_OCHENTA * (falta / aporta);
    return Math.floor(sugerida * fraccion * 10) / 10;
};
